<template>

  <transition name="fade">
    <div id="result">
 
      <ul>
        <list-item 
          v-for="(goal, index) in collection" 
          v-on:selected="onClick"
          :goal="goal" 
          :index="index"
          />
      </ul>
  
    </div>
  </transition>

</template>

<script>


import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import { findWhere } from '@/helpers/ArrayUtils' 
import ListItem from 'src/components/results/list-item'

export default {

  name: 'swipeup',
  
  components: {
    ListItem
  },
  
  data() {
    return { 
    }
  },
  
  computed: {

    ...mapState('app', ['loading']),
    ...mapState('question', ['collection', 'GOALS', 'goal']) ,

    targetEmotion() { 
      return (this.goal) ? this.goal.copy.intro : ''; 
    } 
  },
  
  mounted() {
    let li = this.$el.querySelectorAll('li');
    for (var i = 0; i < li.length; i++) {
      TweenMax.to(li[i], 1, {
        opacity: 1,
        ease: 'Sine.easeInOut',
        delay: 2 + (0.3 * i)
      })
    }
  },
  
  beforeDestroy() {},
  
  methods: {
 
    ...mapMutations('question', [
      'setTargetIndex'
    ]),

    isActive(id) {
      let goal = findWhere( this.collection, {id: id});
      return (!goal.complete); 
    },

    onClick(event){  
      this.setGoalById(event.id);
    },

    setGoalById(id) { 
      let goal = findWhere( this.collection, {id: id});
      if(!goal.complete){
        this.setTargetIndex(id);
        this.$router.replace({ name: 'question' });
      }
    }
  },

  watch: { 
    'loading.completed'(val){
      if(val){ }
    },

  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#result
  +full()

  #list-item
    opacity: 0;

    &:nth-child(1)
      text-align: center;
      top: 8rem;
      width: 100%;
      transform: rotate(-3deg);

    &:nth-child(2) 
      right: 8rem;
      top: 29rem;
      transform: rotate(-5deg);

    &:nth-child(3)
      top: 39rem;
      left: 5.5rem;
      transform: rotate(6deg);

    &:nth-child(4)
      top: 50rem;
      transform: rotate(2deg);
      right: 5rem;

  .replay
    background-image: url('~assets/img/question/result/result_bg_top.png')
    width: 90%;
    height: 113px;
    margin: 6rem auto;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    padding: 2rem 8rem;
    line-height: 2.8rem;
    transform: rotateZ(-3deg);
    letter-spacing: 0.01rem;

  .replay_one
    background-image: url('~assets/img/question/result/result_bg_1.png')
    width: 90%;
    height: 113px;
    margin: 6rem auto;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    padding: 2rem 8rem;
    line-height: 2.4rem;



 


</style>







